
const initialState = {
    categorySearchResults: {
        variants: [],
        filter: [],
        brands: []
    },
    collectionFilter: {},
    variants: {
        state: '',
        data: []
    },
    filter: {
        state: '',
        data: []
    },
    brands: {
        state: '',
        data: []
    },
};

const CommonReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'COMMON':
            //console.log('CommonReducer.state', state, action.payload, typeof action.payload == 'object');
            return { ...state, ...((typeof action.payload == 'object') ? action.payload : {}) };
        default:
            //console.log('CommonReducer.default', state);
            return state;
    }
}

export default CommonReducer;